import {
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Radio,
} from "antd";
import { useTranslation } from "react-i18next";
import { digitsArToFa, digitsFaToEn } from "@persian-tools/persian-tools";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down.svg";
import Regex from "utils/regex";
import OtpInput from "react-otp-input";
import TextArea from "antd/es/input/TextArea";

const FormInputs = (props) => {
  const {
    type,
    label,
    name,
    required,
    placeholder,
    disabled,
    maxlength,
    help,
    pattern,
    patternMessage,
    className,
    numInputsOtp,
    separatorOtp,
    validateTrigger,
    prefix,
    onChange,
    hasFeedback,
    validateDebounce,
    validator,
    checkboxContent,
    extra,
    inputClassName,
    defaultValue,
    selectOptions,
    showDatePickerTime,
    value,
    selectOptionsRender,
    validateStatus,
    onKeyUp,
    inputProps,
    options,
    redioButton = false,
    rules = [],
  } = props;

  const { t } = useTranslation();

  const newRules = [
    {
      required: required,
      message: t("regex.empty"),
    },
    {
      pattern: Regex.firstSpaceBlock,
      message: t("regex.firstSpaceBlock"),
    },
    ...rules,
  ];

  pattern &&
    newRules.push({
      pattern: pattern,
      message: patternMessage,
    });

  validator &&
    newRules.push({
      validator: validator,
    });

  const handleFormInputType = () => {
    switch (type) {
      case "select":
        return (
          <Select
            onChange={onChange}
            defaultValue={defaultValue}
            placeholder={placeholder}
            size="large"
            suffixIcon={<ArrowDown className="w-4 h-4" />}
            options={selectOptions}
            optionRender={selectOptionsRender}
            optionLabelProp="label"
            {...inputProps}
          />
        );

      case "tel":
        return (
          <input
            type="tel"
            inputMode="tel"
            className={`ant-form-item-control-input ant-input-affix-wrapper ${inputClassName}`}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            {...inputProps}
          />
        );

      case "number":
        return (
          <InputNumber
            onChange={onChange}
            controls={false}
            autoComplete="off"
            placeholder={placeholder}
            prefix={prefix}
            className={inputClassName}
            formatter={(value) =>
              digitsFaToEn(digitsArToFa(value.toString())).replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              )
            }
            parser={(value) =>
              digitsFaToEn(digitsArToFa(value.toString())).replace(
                /\$\s?|(,*)/g,
                ""
              )
            }
            defaultValue={defaultValue}
            disabled={disabled}
            {...inputProps}
          />
        );
      case "otp":
        return (
          <OtpInput
            numInputs={numInputsOtp}
            renderSeparator={separatorOtp}
            renderInput={(props) => <input {...props} inputMode="numeric" />}
            inputStyle="otp-input"
            containerStyle="flex-row-reverse justify-center"
            inputType="numeric"
            inputMode="numeric"
            shouldAutoFocus={true}
            // value={value}
            isInputNum={false}
            onChange={onChange}
            pattern="/^[0-9\u0660-\u0669]+$/"
            {...inputProps}
          />
        );
      case "checkbox":
        return (
          <Checkbox onChange={onChange} {...inputProps}>
            {checkboxContent}
          </Checkbox>
        );
      case "radio":
        const Component = redioButton ? Radio.Button : Radio;
        return (
          <Radio.Group onChange={onChange} {...inputProps}>
            {options?.map((item) => (
              <Component key={item?.key || item} value={item?.key || item}>
                {item.title || item}
              </Component>
            ))}
          </Radio.Group>
        );
      case "password":
        return (
          <Input.Password
            placeholder={placeholder}
            autoComplete="new-password"
            disabled={disabled}
            visibilityToggle={true}
            className={inputClassName}
            onChange={onChange}
            onKeyUp={onKeyUp}
            {...inputProps}
          />
        );
      case "datePicker":
        return (
          <DatePicker
            onChange={onChange}
            format={showDatePickerTime ? "YYYY/MM/DD hh:mm" : "YYYY/MM/DD"}
            multiple={showDatePickerTime}
            value={value}
            {...inputProps}
          />
        );
      case "textArea":
        return (
          <TextArea
            autoSize
            placeholder={placeholder}
            className={inputClassName}
            {...inputProps}
          />
        );
      case "default":
      default:
        return (
          <Input
            className={`input ${inputClassName}`}
            placeholder={placeholder}
            disabled={disabled}
            maxLength={maxlength}
            defaultValue={defaultValue}
            {...inputProps}
          />
        );
    }
  };
  return (
    <>
      <Form.Item
        labelCol={{ xs: 24 }}
        wrapperCol={{ xs: 24 }}
        label={label}
        name={name}
        rules={newRules}
        help={help}
        extra={extra}
        className={className}
        validateTrigger={validateTrigger || "onChange"}
        hasFeedback={hasFeedback}
        validateDebounce={validateDebounce}
        validateStatus={validateStatus}
      >
        {handleFormInputType()}
      </Form.Item>
    </>
  );
};

export default FormInputs;
